export const THREE_MOUTH = 3600 * 1000 * 24 * 92;
export const ONE_WEEK = 3600 * 1000 * 24 * 7;
export const ONE_SECOND_SHORT = 24 * 3600 * 1000 - 1000;

export function getToday() {
  const now = new Date();
  return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
}

export function getStartDate(v: Date | string) {
  const vDate = new Date(v);
  const result = new Date(
    vDate.getFullYear(),
    vDate.getMonth(),
    vDate.getDate()
  );
  return result;
}

export function getEndDate(v: Date | string) {
  const vDate = new Date(v);
  const result = new Date(
    vDate.getFullYear(),
    vDate.getMonth() + 1,
    vDate.getDate()
  );
  return result;
}
